export type ReasonID = symbol;
